<template>
    <div>
        <modal
            name="feedback"
            class="feedback-modal"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            width="40%"
            height="auto"
        >
            <div class="modal__content">
                <div class="modal__header">
                    Lähetä palautetta tai idea
                </div>
                <div class="feedback-form">
                    <form v-on:submit.prevent="sendFeedback" method="post" name="send-feedback" class="default">
                        <div class="form-group" :class="{ 'form-group--error': $v.name.$error }">
                            <label>Nimesi</label>
                            <input type="text" placeholder="Nimesi" v-model.trim="$v.name.$model"/>
                        </div>
                        <div class="form-group" :class="{ 'form-group--error': $v.email.$error }">
                            <label>Sähköpostiosoitteesi</label>
                            <input
                                type="text"
                                placeholder="Sähköpostiosoitteesi"
                                v-model.lazy="$v.email.$model"/>
                        </div>
                        <div class="form-group" :class="{ 'form-group--error': $v.subject.$error }">
                            <label>Aihe</label>
                            <input type="text" placeholder="Palautteesi / viestisi aihe" v-model.trim="$v.subject.$model"/>
                        </div>
                        <div class="form-group" :class="{ 'form-group--error': $v.message.$error }">
                            <label>Viestisi</label>
                            <textarea
                                rows="12"
                                v-model="$v.message.$model"
                                id="message"
                                @focusin="removeMessagePlaceholder"
                                @focusout="addMessagePlaceholder"
                            ></textarea>
                        </div>
                    </form>
                </div>
                <div class="modal__footer text-right">
                    <span class="btn btn--hollow btn--small" @click="closeModal">Peruuta</span>
                    <button class="btn btn--call-to-action btn--small" @click="sendFeedback">
                        Lähetä
                    </button>
                </div>

            </div>
        </modal>
        <div class="feedback-footer">
            <a @click="openModal">Lähetä palautetta tai idea </a>
        </div>

    </div>
</template>

<script>
    import required from 'vuelidate/lib/validators/required';
    import email from 'vuelidate/lib/validators/email';
    import FormData from '../modules/FormData';
    import Messages from '../modules/Messages';
    import Routes from '../modules/Routes';

    export default {
        model: {
            prop: 'accepted',
            event: 'change'
        },
        props: {
            url: {
                type: String,
                default: null
            },
            token: {
                type: String
            },
            initialMessage: {
                type: String,
                default: 'Viestisi / palautteesi'
            }
        },
        data() {
            return {
                name: '',
                email: '',
                subject: '',
                message: this.initialMessage,
                modalState: 'closed'
            };
        },
        validations: {
            name: {
                required
            },
            email: {
                required,
                email
            },
            subject: {
                required
            },
            message: {
                required
            }
        },
        methods: {
            openModal() {
                this.modalState = 'open';
                this.$modal.show('feedback');
                this.$ga.event('Feedback', 'Modal opened');
                gtag('event', 'view_feedback_form');
            },
            closeModal() {
                this.modalState = 'closed';
                this.$modal.hide('feedback');
                return false;
            },
            sendFeedback() {
                if (this.$v.$invalid) {
                    Messages.error('Tarkista, että käytit kaikki tiedot');
                    return;
                }
                let formData = new FormData({ ...this.$data, url: this.url }, this.token);
                this.$http.post(this.getUrl(), JSON.stringify(formData.parseFeedbackData(this)), {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then((response) => {
                    Messages.successFromResponse(response);
                    this.closeModal();
                    this.$ga.event('Feedback', 'Sent succesfully');
                    gtag('event', 'send_feedback');
                }, (response) => {
                    Messages.errorFromResponse(response);
                    this.$ga.event('Feedback', 'Sending failed');
                });
            },
            getUrl() {
                return Routes.generate('_public_api_send_feedback');
            },
            removeMessagePlaceholder() {
                if (this.message === this.initialMessage) {
                    this.message = ' ';
                }
            },
            addMessagePlaceholder() {
                if (!this.message || /^\s*$/.test(this.message)) {
                    this.message = this.initialMessage;
                }
            }
        }
    };
</script>
